const MENZZO_SAV_HOSTNAMES = new Set(["sav.menzzo.fr", "www.sav.menzzo.fr"]);

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);

export function getCurrentHostname(): string {
  return window.location.hostname.toLowerCase();
}

export function isMenzzoSavHost(
  hostname: string = getCurrentHostname()
): boolean {
  const normalizedHostname = hostname.trim().toLowerCase();

  if (MENZZO_SAV_HOSTNAMES.has(normalizedHostname)) {
    return true;
  }

  return (
    process.env.NODE_ENV === "development" &&
    LOCAL_HOSTNAMES.has(normalizedHostname)
  );
}
